import React, { useEffect, useContext, useState } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { Link, useNavigate } from 'react-router-dom';
import JobService from "../Controller/JobController";
import CreateJobMobile from "./JobForms/CreateJobMobile";
import JobsPartListMobile from "./JobForms/JobsPartListMobile";
import AssetJobListMobile from "./JobForms/AssetJobListMobile";
import JobsCommentListMobile from "./JobForms/JobsCommentListMobile";
import JobDocumentMobileList from "./JobForms/JobDocumentMobileList";
import CreateJobSignature from "./JobForms/CreateJobSignature";
import Common from '../../Common/Common';
import { handleSubmit } from "../Controller/CreateJobDocumentController";
import IssueStatusService from "../../Setup/controller/IssueStatusController/IssueStatusController";
import { handleChange, handleSubmit as handleSubmitStatus } from "../Controller/CreateJobController";
import Swal from 'sweetalert2';
import JobEngineerListMobile from "./JobForms/JobEngineerListMobile";
import CreateJobEngineerMobile from "./JobForms/CreateJobEngineerMobile";
import { formatDateWithFns } from '../../Common/DateInputFormat';
function JobsDetailMobile() {

    const navigate = useNavigate();
    const JobID = localStorage.getItem("JobID");
    const UserID = localStorage.getItem("UserID");
    const { theme } = useContext(ThemeContext);
    const getCurrentDateTime = () => {
        const now = new Date();
        const date = now.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        const time = now.toTimeString().split(' ')[0]; // Format: HH:MM:SS
        return { date, time };
    };
    const { date, time } = getCurrentDateTime();
    const fileInputRef = React.useRef(null);

    const [jobName, setJobName] = useState("New Job");
    const [customerName, setCustomerName] = useState("");
    const [Site, setSite] = useState("");
    const [Contact, setContact] = useState("");
    const [CallTime, setCallTime] = useState("");
    const [jobTitle, setJobTitle] = useState("");

    const [accountRef, setAccountRef] = useState("");
    const [telephone, setTelephone] = useState("");
    const [address1, setAddress1] = useState("");
    const [category, setCategory] = useState("");
    const [priority, setPriority] = useState("");
    const [status, setStatus] = useState("");
    const [startDate, setStartDate] = useState("");
    const [startTime, setStartTime] = useState("");

    const [currentJobID] = useState(JobID);
    const [activeScreen, setActiveScreen] = useState("home");
    const [activeModule, setActiveModule] = useState(null);

    const [showStatusModal, setShowStatusModal] = useState(false);
    const [statusList, setStatusList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isClosed, SetIsClosed] = useState("0");
    const [tableData, setTableData] = useState([]);
    const [formData, setFormData] = useState({
        CustomerID: 0,
        IssueID: 0,
        CustomerName: '',
        FK_ClientBranch_ID: 0,
        FK_ClientContact_ID: 0,
        IssueTitle: "",
        Estimate: "0.00",
        mon_JobCost: "0.00",
        Invoiced: 0,
        FK_Supplier_ID: 0,
        ProjectID: 0,
        ProjectCategoriesID: 0,
        CallTypeID: 1,
        ReportedBy: "",
        DateInvoiced: date,
        vc_SupplierInvoiceNo: "",
        FK_Contract_ID: 0,
        AsbestosChecked: "0",
        TimeToCall: date,
        CallTime: time,
        AlertDays: "1",
        AlertTime: "0",
        UserID: "0",
        IssuePriorityID: 0,
        IssueStatusID: 0,
        StatusName: "",
        BranchName: "",
        CustomerName1: "",
        PriorityName: "",
        Address1: "",
        Phone1: "",
        CategoryName: "",
        EndDate: "",
        EndTime: ""

    });
    useEffect(() => {
        fetchIssueStatus();
        if (JobID > 0) {
            fetchJobDetailDetail(JobID);
            fetchJobEngineers();
        } else {
            setJobName("New Job");
        }
    }, [JobID]);
    const fetchJobEngineers = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            setTableData([]);

            const formatDate = (dateString) => {
                if (!dateString) return null;
                const date = new Date(dateString);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                const year = date.getFullYear();
                return `${year}/${month}/${day}`;
            };
            if (JobID > 0) {
                let jobEngineers = await JobService.GetJobEnginners(redirectCallback, JobID);
                debugger;
                jobEngineers = jobEngineers.filter(x => x.UserID.toString() === UserID.toString());
                debugger;
                const selectedPartsData = jobEngineers.map(detail => ({

                    UserID: detail.UserID,
                    EngineerTimeID: detail.EngineerTimeID,
                    DisplayName: detail.DisplayName,
                    DepartBaseDate: formatDate(detail.DepartBaseDate),
                    DepartBaseTime: detail.DepartBaseTime ? detail.DepartBaseTime.slice(0, 5) : "",
                    ReturnBaseDate: formatDate(detail.ReturnBaseDate),
                    ReturnBaseTime: detail.ReturnBaseTime ? detail.ReturnBaseTime.slice(0, 5) : "",
                    HoursTravel: detail.HoursTravel,
                    StartDate: formatDate(detail.StartDate),
                    StartTime: detail.StartTime ? detail.StartTime.slice(0, 5) : "",
                    EndDate: formatDate(detail.EndDate),
                    EndTime: detail.EndTime ? detail.EndTime.slice(0, 5) : "",
                    HoursDate: detail.HoursDate,
                    PayRateID: detail.PayRateID,
                    Other: detail.Other,

                    // Map other fields as needed
                }));

                setTableData(selectedPartsData);
            }
        } catch (error) {
            console.error('Error fetching supplier details:', error);
        }
    };
    const fetchIssueStatus = async () => {
        try {
            const redirectCallback = () => navigate('/');
            let list = await IssueStatusService.GetAllIssueStatus(redirectCallback);
            list = list.filter(x => x.IsCompleted < 1);
            setStatusList(list);

            const defaultStatus = list.find(status => status.IsDefault === 1);
            if (defaultStatus) {

                setFormData(prevFormData => ({
                    ...prevFormData,
                    IssueStatusID: defaultStatus.ID, // Assuming IssueStatusID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching issue statuses:', error);
        }
    };
    const fetchJobDetailDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);
                SetIsClosed(jobDetail[0].IsCompleted);
                setJobName(`Job No: ${jobDetail[0].bnt_OrderNumber}`);
                localStorage.setItem("Closed", jobDetail[0].IsCompleted.toString());
                const formattedDetail = {
                    ...jobDetail[0],
                    DateInvoiced: jobDetail[0].DateInvoiced
                        ? new Date(jobDetail[0].DateInvoiced).toISOString().split('T')[0]
                        : null,

                    TimeToCall: jobDetail[0].TimeToCall
                        ? new Date(jobDetail[0].TimeToCall).toISOString().split('T')[0]
                        : null,
                    CustomerID: jobDetail[0].ClientCompanyID,
                    AsbestosChecked: jobDetail[0].AsbestosChecked != null
                        ? jobDetail[0].AsbestosChecked.toString()
                        : null,

                    Estimate: jobDetail[0].Estimate,
                    mon_JobCost: jobDetail[0].mon_JobCost,
                   

                };


                setFormData(formattedDetail);



            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };


    /* const fetchJobDetailDetail = async (newJobID) => {
         try {
             const jobDetail = await JobService.GetJobByID(navigate, newJobID);
 
             if (jobDetail && jobDetail.length > 0) {
 
                 const j = jobDetail[0];
 
                 setJobName(`Job No. ${j.bnt_OrderNumber}`);
                 setCustomerName(j.CompanyName);
                 setSite(j.BranchName);
                 setCallTime(j.CallTime);
                 setJobTitle(j.IssueTitle);
 
                 setAccountRef(j.AccountRef);
                 setTelephone(j.Telephone);
                 setAddress1(j.Address1);
                 setCategory(j.CategoryName);
                 setPriority(j.PriorityName);
                 setStatus(j.StatusName);
                 setStartDate(j.TimeToCall);
                 setStartTime(j.CallTime);
                 setContact(j.ContactName);
             }
 
         } catch (error) {
             Swal.fire({
                 icon: 'error',
                 title: 'Error',
                 text: error,
                 timer: 1500,
                 showConfirmButton: false
             });
         }
     };*/

    // =========================
    // ADD DOCUMENT
    // =========================
    const handleAddDocumentClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const goBack = () => {
        setActiveScreen("home");
        setActiveModule(null);
    };
    const removeEngineer = async (index, ID) => {

        const confirmed = window.confirm("Are you sure you want to delete this record?");
        if (confirmed) {
            try {
                if (ID > 0) {
                    const redirectCallback = () => navigate('/');
                    await JobService.DeleteEngineerByID(redirectCallback, ID);
                    let JobCostID = localStorage.getItem('JobCostID');
                    JobCostID = JobCostID + 1;
                    localStorage.setItem('JobCostID', JobCostID);
                }
                const updatedTableData = [...tableData];
                updatedTableData.splice(index, 1);
                setTableData(updatedTableData);

            } catch (error) {
                console.error('Error deleting job:', error);
            }
        }
    };
    const handleDirectUpload = async (event) => {

        const file = event.target.files[0];
        if (!file) return;

        const uploadData = {
            IssueID: currentJobID,
            FileName: '',
            Path: file.name,
            Name: file.name,
            Description: '',
            File: file,
            CompanyDocument: 0,
            DocID: 0
        };

        try {

            await handleSubmit(
                event,
                uploadData,
                () => { },
                () => { },
                () => { },
                () => { }
            );

            Swal.fire({
                icon: 'success',
                title: 'Uploaded',
                text: 'Document uploaded successfully',
                timer: 1200,
                showConfirmButton: false
            });

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Upload Failed'
            });
        }

        event.target.value = '';
    };
    const handleEngineerEdit = (engineer) => {

        setActiveModule({
            key: "editEngineer",
            title: "Edit Engineer",
            component: (
                <CreateJobEngineerMobile
                    JobID={currentJobID}
                    EngineerData={engineer}
                    onSaved={fetchJobEngineers}
                    handleBack={goBack}
                />
            )
        });

        setActiveScreen("inner");
    };

    // =========================
    // MODULES
    // =========================
    const modules = [

        {
            key: "parts",
            title: "Parts",
            icon: "assets/img/resources/jobParts.png",
            component: <JobsPartListMobile JobID={currentJobID} />
        },
        {
            key: "assets",
            title: "Assets",
            icon: "assets/img/resources/jobAssets.png",
            component: <AssetJobListMobile JobID={currentJobID} />
        },
        {
            key: "engineers",
            title: "Engineers",
            icon: "assets/img/resources/Lead-add.png",
            component: (
                <JobEngineerListMobile
                    JobID={currentJobID}
                    tableData={tableData}
                    isClosed={isClosed}
                    handleEditClick={handleEngineerEdit}
                    removeRow={removeEngineer}
                    formatDateWithFns={formatDateWithFns}
                    refresh={fetchJobEngineers}
                />
            )
        },

        // NEW
        {
            key: "addEngineer",
            title: "Add Engineer",
            icon: "assets/img/resources/contacts-add.png",
            component: (
                <CreateJobEngineerMobile
                    JobID={currentJobID}
                    engineer={null}
                    onSaved={fetchJobEngineers}
                    handleBack={goBack}
                />
            )
        },
        {
            key: "docs",
            title: "Documents/Images",
            icon: "assets/img/resources/jobDocuments.png",
            component: <JobDocumentMobileList JobID={currentJobID} />
        },
        {
            key: "addDoc",
            title: "Add Image",
            icon: "assets/img/resources/jobDocuments.png",
            isAction: true
        },

        {
            key: "updates",
            title: "Updates",
            icon: "assets/img/resources/jobUpdates.png",
            component: <JobsCommentListMobile JobID={currentJobID} autoOpen={"false"} handleBack={goBack} />
        },
        {
            key: "updates",
            title: "Add Update",
            icon: "assets/img/resources/jobUpdates.png",
            component: <JobsCommentListMobile JobID={currentJobID} autoOpen={"true"} handleBack={goBack} />
        },
        {
            key: "signature",
            title: "Signature",
            icon: "assets/img/resources/job_signature.png",
            component: <CreateJobSignature JobID={currentJobID} />
        }
    ];

    const openModule = (module) => {
        setActiveModule(module);
        setActiveScreen("inner");
    };

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        debugger;
        setEndDate(value);
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <div className="container-fluid p-0">

            <Common />

            <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleDirectUpload}
            />

            {/* HEADER */}
            <div className="modal-header text-white d-flex justify-content-between align-items-center px-3 py-2"
                style={{ backgroundColor: "#134e82" }}>

                {activeScreen === "inner" ? (
                    <button className="btn btn-light btn-sm" onClick={goBack}>
                        ← Back
                    </button>
                ) : <div />}

                <h5 className="m-0 text-white flex-grow-1 text-center">
                    {jobName}
                </h5>

                <Link to="/JobsListMobile" className="btn btn-light btn-sm">
                    Job List
                </Link>
            </div>

            {/* HOME */}
            {activeScreen === "home" && (
                <>
                    {/* JOB CARD */}
                    <div className="job-info-card">

                        <div className="job-title">{formData.IssueTitle}</div>

                        {/* GRID LAYOUT (REDUCED SPACE) */}
                        <div className="job-grid">

                            <div className="job-item">
                                <small>Customer</small>
                                <div>{formData.CustomerName}</div>
                            </div>

                            <div className="job-item">
                                <small>Site</small>
                                <div>{formData.BranchName}</div>
                            </div>

                            <div className="job-item">
                                <small>Contact</small>
                                <div>{formData.ContactName}</div>
                            </div>

                            <div className="job-item">
                                <small>Account Ref</small>
                                <div>{formData.AccountRef}</div>
                            </div>

                            <div className="job-item">
                                <small>Telephone</small>
                                <div>{formData.Phone1}</div>
                            </div>

                            <div className="job-item">
                                <small>Address</small>
                                <div>{formData.Address1}</div>
                            </div>
                            <div className="job-item">
                                <small>Post Code</small>
                                <div>{formData.Postcode}</div>
                            </div>

                            <div className="job-item">
                                <small>Category</small>
                                <div>{formData.CategoryName}</div>
                            </div>

                            <div className="job-item">
                                <small>Priority</small>
                                <div>{formData.PriorityName}</div>
                            </div>

                            <div className="job-item">
                                <small>Status</small>

                                <div className="d-flex justify-content-between align-items-center">
                                    <span>{formData.StatusName}</span>

                                    <button
                                        type="button"
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            fontSize: "16px"
                                        }}
                                        onClick={() => setShowStatusModal(true)}
                                    >
                                        ✏️
                                    </button>
                                </div>
                            </div>

                            <div className="job-item">
                                <small>Start Date</small>
                                <div>{formData.TimeToCall}</div>
                            </div>

                            <div className="job-item">
                                <small>Start Time</small>
                                <div>{formData.CallTime}</div>
                            </div>
                            <div className="job-item">
                                <small>End Date</small>
                                <div>{formData.EndDate}</div>
                            </div>
                             <div className="job-item">
                                <small>End Time</small>
                                <div>{formData.EndTime}</div>
                            </div>

                            <div className="job-item">
                                <small>Order No</small>
                                <div>{formData.vc_SupplierInvoiceNo}</div>
                            </div>

                        </div>
                    </div>

                    {/* ACTIONS */}
                    <h6 className="px-3 text-muted">Other Actions</h6>

                    <div className="card-grid">
                        {modules.map((m) => (
                            <div
                                key={m.key}
                                className="action-card"
                                onClick={() => {
                                    if (m.isAction) {
                                        handleAddDocumentClick();
                                    } else {
                                        openModule(m);
                                    }
                                }}
                            >
                                <div className="card-content">
                                    <img src={m.icon} alt={m.title} />
                                    <span>{m.title}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}

            {/* INNER */}
            {activeScreen === "inner" && activeModule && (
                <div className="inner-screen">
                    <h6>{activeModule.title}</h6>
                    <div className="inner-body">{activeModule.component}</div>
                </div>
            )}

            {/* STYLE */}
            <style>{`
                .job-info-card {
                    background: #fff;
                    margin: 10px;
                    padding: 12px;
                    border-radius: 12px;
                    box-shadow: 0 2px 6px rgba(0,0,0,0.06);
                }

                .job-title {
                    font-size: 15px;
                    font-weight: 600;
                    color: #134e82;
                    margin-bottom: 8px;
                }

                .job-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 8px 10px;
                }

                .job-item small {
                    font-size: 10px;
                    color: #888;
                }

                .job-item div {
                    font-size: 13px;
                    font-weight: 500;
                    color: #333;
                }

                .card-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 12px;
                    padding: 12px;
                }

                .action-card {
                    background: #fff;
                    border-radius: 10px;
                    padding: 14px;
                    box-shadow: 0 2px 6px rgba(0,0,0,0.08);
                }

                .card-content {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }

                .card-content img {
                    width: 26px;
                    height: 26px;
                }
                    .status-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

.status-modal {
    background: #fff;
    padding: 15px;
    width: 90%;
    border-radius: 10px;
}
            `}</style>
            {showStatusModal && (
                <div className="status-modal-backdrop">
                    <div className="status-modal">

                        <h6>Update Status</h6>

                        <select
                            className="form-control"
                            value={selectedStatus || ""}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                        >
                            <option value="0">Select Status</option>
                            {statusList.map((s) => (
                                <option key={s.ID} value={s.ID}>
                                    {s.StatusName}
                                </option>
                            ))}
                        </select>

                        



                        <div className="d-flex justify-content-end mt-3 gap-2">
                            <button
                                className="btn btn-secondary btn-sm"
                                onClick={() => setShowStatusModal(false)}
                            >
                                Cancel
                            </button>

                            <button
                                className="btn btn-primary btn-sm"
                                onClick={async () => {

                                    try {

                                        await JobService.UpdateJobStatusMobile(currentJobID, selectedStatus);

                                        // update UI instantly
                                        const newStatus = statusList.find(
                                            x => x.ID == selectedStatus
                                        )?.StatusName;

                                        setStatus(newStatus);

                                        setShowStatusModal(false);

                                        Swal.fire({
                                            icon: 'success',
                                            title: 'Updated',
                                            timer: 1000,
                                            showConfirmButton: false
                                        });
                                        setTimeout(() => {
                                            navigate("/JobsListMobile");
                                        }, 1000);

                                    } catch (error) {
                                        Swal.fire({
                                            icon: 'error',
                                            title: 'Error updating status'
                                        });
                                    }

                                }}
                            >
                                Update
                            </button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
}

export default JobsDetailMobile;